import { Message } from './message';

export class MessagesData {
  messages: Message[] = [];

  pageNumber = 0;

  numberOfItems = 20;

  // this will be false when there is no more messages for current channel on backend
  getNextPage = true;
}
